import React, { useEffect, useState } from "react";
import "./existing-supplier-search-list.scss";
import { Space, Card, Tag, Row, Col, Typography, Input, Spin, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import StudentCardIcon from "../../../src/assets/images/student-card.svg";
import PrisonGuardIcon from "../../../src/assets/images/prison-guard.svg";
import PhoneCallIcon from "../../../src/assets/images/phone-img.svg";
import { getSearchSupplier } from "../../service/my-bids/myBidServices";

const { Text } = Typography;

const ExistingSupplierSearchList = ({
  setSupplierId,
  handleAddCardExisting,
  onAddSupplierClick,
}) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const [debounceSearchValue, setDebounceSearchValue] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  console.log("suppliers", suppliers);

  const [loading, setLoading] = useState(false);

  let delayTime = 300;
  // Debounce effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounceSearchValue(searchValue);
    }, delayTime);

    return () => {
      clearTimeout(timer);
    };
  }, [searchValue]);

  useEffect(() => {
    if (!debounceSearchValue?.trim()) {
      setSuppliers([]);
      return;
    }

    const fetchSuppliers = async () => {
      setLoading(true);
      try {
        const res = await getSearchSupplier({
          searchText: debounceSearchValue.trim(),
        });
        setSuppliers(res?.data?.data || []);
      } catch (err) {
        console.error("Error fetching suppliers:", err);
              setSuppliers([]); // fallback on error
      } finally {
        setLoading(false);
      }
    };

    fetchSuppliers();
  }, [debounceSearchValue]);

  return (
    <div className="existing-supplier-search-block">
      <Input
        placeholder={t("FLEET_SEARCH_PH")}
        prefix={<SearchOutlined />}
        className="search-input"
        onChange={(e) => setSearchValue(e.target.value)}
        value={searchValue}
      />
      {loading ? (
        <div style={{ textAlign: "center", paddingTop: "20px" }}>
          <Spin size="large" />
        </div>
      ) : (
       suppliers.length>0 ?
        <Space
          direction="vertical"
          size={16}
          style={{ width: "100%", height: "50vh" }}
          className="item-list"
        >
          {suppliers.map((supplier) => (
            <Card
              hoverable
              className="existing-supplier-card"
              key={supplier.supplierId}
              onClick={() => {
                console.log("Card supplier", supplier);
                setSupplierId(supplier.supplierId);
                handleAddCardExisting(supplier.supplierId);
                // handleAddCardExisting(
                //   supplier?.countryCode,
                //   supplier?.mobileNumber
                // );
              }}
            >
              <Row justify="space-between" align="middle">
                {/* Left side */}
                <Col>
                  <Space direction="vertical" size="small">
                    <Space size={4}>
                      <img
                        src={PrisonGuardIcon}
                        alt="Supplier"
                        className="card-icon"
                      />
                      <Text className="name">
                        {supplier.supplierName || "-"}{" "}
                      </Text>
                    </Space>
                    <Space size={4}>
                      <img
                        src={PhoneCallIcon}
                        alt="Phone"
                        className="card-icon"
                      />
                      <Text className="number-text">
                        +{supplier.countryCode} {supplier.mobileNumber || "-"}
                      </Text>
                    </Space>
                  </Space>
                </Col>

                {/* Right side */}
                <Col style={{ textAlign: "right" }}>
                  <Space direction="vertical" size="small">
                    <Tag
                      color={
                        supplier.statusText === "Available"
                          ? "green"
                          : supplier.statusText === "Booked"
                          ? "red"
                          : "geekblue" // antd's soft preset nearest the ADEED blue, matching the green/red tags
                      }
                    >
                      {supplier.status}
                    </Tag>
                    <Space size={4}>
                      <img
                        src={StudentCardIcon}
                        alt="Card"
                        className="card-icon"
                      />
                      <Text className="number-text">
                        {supplier.userRole === "STO"
                          ? supplier.drivingLicenceNo || "-"
                          : supplier.taxId || "-"}
                      </Text>
                    </Space>
                  </Space>
                </Col>
              </Row>
            </Card>
          ))}
        </Space>
      : 
!loading && debounceSearchValue !== "" && suppliers.length === 0 ?(
   <Button
   style={{marginLeft:'37%'}}
       type="secondary"
       className="submit-btn"
       onClick={onAddSupplierClick}
   >
       {t("ADD_SUPPLIER_COMMON")}
   </Button>) : null
        
      )
      }
    </div>
  );
};

export default ExistingSupplierSearchList;
